<template>
	<div class="user_main_settings">
		<div class="d-flex flex-start w-100">
			<div class="mr-2 hidden-md-down">
            <span class="icon-stack icon-stack-lg">
                <i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
	            <i class="fa fa-long-arrow-right icon-stack-1x opacity-100 color-white"></i>
            </span>
			</div>
			<div class="d-flex flex-fill">
				<div class="flex-fill">
					<span class="h5">Налаштування параметрів переадресації службових записок</span>
				</div>
			</div>
		</div>

		<div class="row pt-5">
			<div class="col-lg-4 col-md-4 col-xs-12 col-xl-4">
				<div class="user_add cursor-pointer" v-if="!is_user_redirect">
					<div class="add user d-inline-flex flex-row flex-nowrap text-truncate align-items-center gap-3"
						 @click="add_user">
						<i title="" style="font-size: 22px;" class="fa add_user fa-plus-square"
						   data-type="delegate_users"></i>
						<span
							class="ml-1 fw-bold fs-lg text-wrap text-truncate">Оберіть користувача для переадресації</span>
					</div>
				</div>

				<div class="user_to_fire" v-else>
					<user_block v-if="obj_to_null(this.user_redirect)"
								:key="user_redirect.id"
								v-bind:can_del=true
								v-bind:del_triger="remove_fire_from_doc"
								v-bind:user="user_redirect">
					</user_block>
				</div>
			</div>

			<div class="col-lg-6 col-md-6 col-xs-12 col-xl-6">
				<div class="form-group mt-2 mt-md-0">
					<label class="fw-bold fs-lg text-wrap text-truncate">
						Шаблон службової для переадресації
					</label>

					<div v-if="questions_list.length > 0" class="d-flex flex-row flex-nowrap align-items-center">
						<v-select
							v-model="question_selected"
							class="imc_reasons w-100"
							label="title"
							:options="questions_list"
							:filterable="true"
							placeholder="Оберіть питання для додавання в список"
						>
							<template slot="no-options">
								Оберіть питання для додавання в список
							</template>

							<template slot="option" slot-scope="option">
								<div class="d-flex p-1 mr-2">
									<div class='icon-stack fs-xxl'>
										<i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
										<i class="base base-7 icon-stack-2x opacity-100 color-primary-300"></i>
										<i class="fal fa-bookmark icon-stack-1x opacity-100 color-white"></i>
									</div>

									<div class="org_title ml-2">
										{{ option.title }}
									</div>
								</div>
							</template>
						</v-select>
						<button class="ml-2 btn btn-success" @click.prevent="addTemplateQuestions">Додати</button>
					</div>
				</div>
			</div>
		</div>

		<div v-for="item in questions_redirect_list" class="row pt-2">
			<div class="col-lg-10 col-md-10 col-xs-12 col-xl-10">
				<div class="user_to_fire">
					<div class="user_profile bg-gradient-primary bd-callout bd-callout-info position-relative p-3">
						<div
							class="rem_user_ins position-absolute btn btn-icon btn-sm btn-danger shadow waves-effect waves-themed cursor-pointer"
							style="top: 2px; right: 2px;"
							@click.prevent="deleteQuestionRedirect(item?.id)"
						>
							<i class="fal fa-times">
							</i>
						</div>
						<span class="fs-xl text-wrap">
							{{ item.title }}
						</span>
					</div>
				</div>
			</div>
		</div>

		<div class="mt-3 text-right">
			<button type="button"
					v-on:click="save_settings"
					class="btn btn-lg btn-outline-primary waves-effect waves-themed">
				<span class="fal fa-check mr-1"></span>
				Зберегти
			</button>
		</div>

	</div>
</template>

<script>
import {mapGetters} from "vuex";
import vSelect from 'vue-select'
import user_block from "../../../shared/user/user_block/user_block.vue";

export default {
	name: "main_settings",

	components: {
		vSelect,
		user_block,
	},

	props: {
		user_id: {
			type: Number,
			required: true
		}
	},

	data() {
		return {
			is_load: false,
			user_templates: [],
			uniq_u: 'fire_user_add',
			user_redirect: null,
			remove_fire_from_doc: 'remove_fire',
			questions_list: [],
			question_selected: null,
			questions_redirect_list: [],
		}
	},

	created() {
		EventBus.$on('selected_users', e => {
			if (e.uniq === this.uniq_u) {
				EventBus.$emit('close_u_filter');
				this.load_user_info(e.users[0]);
			}
		});

		EventBus.$on(this.remove_fire_from_doc, e => {
			this.user_redirect = null;
		});
		EventBus.$on('user_added', this.userAdded);
	},
	beforeDestroy() {
		EventBus.$off('selected_users', e => {
			if (e.uniq === this.uniq_u) {
				EventBus.$emit('close_u_filter');
				this.load_user_info(e.users[0]);
			}
		});

		EventBus.$off(this.remove_fire_from_doc, e => {
			this.user_redirect = null;
		});

	},

	methods: {
		userAdded() {
			this.load_data();
		},
		load_data() {
			this.get_questions_list();
			this.get_questions_redirect();
		},
		add_user() {
			EventBus.$emit('load_users_filter', {
					uniq: this.uniq_u,
					active: [],
				}
			);
		},
		addTemplateQuestions() {
			const findQuestion = this.questions_redirect_list.find(item => item?.id === this.question_selected?.id);
			if (findQuestion !== undefined || this.question_selected === null) {
				return;
			}
			this.questions_redirect_list.push(this.question_selected);
		},
		deleteQuestionRedirect(itemId) {
			const findIndex = this.questions_redirect_list.findIndex(item => item?.id === itemId);
			if (findIndex >= 0) {
				this.questions_redirect_list.splice(findIndex, 1);
			}
		},
		async save_settings() {
			this.$emit('loading', 'main_settings', true);
			await api.post('/memorandum/questions/redirect/user/' + this.user_id, {
				'user_id_redirect': this.user_redirect?.id ?? null,
				'questions_ids': this.questionsIds,
			}).then(({data}) => {
				this.$emit('loading', 'main_settings', false);
				IMC_CORE.snackbar('Успішно збережено');
				if (data.status === "operation_success") {
					this.load_data();
				}
			}).catch(({response}) => {
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
				this.$emit('loading', 'main_settings', false);
			});
			console.log(this.questions_list);
		},

		async get_questions_list() {
			await api.get('/memorandum/questions/adjust/user/' + this.user?.id ?? '').then(({data}) => {
				if (data.status === "operation_success") {
					this.questions_list = data.data;
				}
			}).catch(err => {
				console.log(err);
			});
		},
		async get_questions_redirect() {
			await api.get('/memorandum/questions/redirect/user/' + this.user?.id ?? '').then(({data}) => {
				if (data.status === "operation_success") {
					this.questions_redirect_list = data.data?.questions ?? [];
					this.user_redirect = data.data?.user_redirect ?? null;
				}
			}).catch(err => {
				console.log(err);
			});
		},
		async load_user_info(user) {
			IMC_CORE.showloading();

			await api.get('/user/' + user.id)
				.then(({data}) => {
					IMC_CORE.hideloading();
					if (data.status === "operation_success") {
						this.user_redirect = data.data;
					} else {
						EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
					}
				}).catch(err => {
					IMC_CORE.hideloading();
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
		},

	},

	computed: {
		...mapGetters({
			'user': "user/getUser",
		}),

		is_user_redirect() {
			return this.user_redirect !== null;
		},
		questionsIds(){
			return this.questions_redirect_list.map((item) => item.id);
		}
	},

}
</script>

<style scoped>

</style>
